import React, { useState, useEffect, useMemo } from 'react'
import Header from '../users/Header'
import NavHeader from '../users/NavHeader'
import { UserAuth } from '../../context/AuthContext'
import ReactPaginate from 'react-paginate';
import SearchField from "react-search-field";
import { FaEdit, FaTrash, FaUserAstronaut } from 'react-icons/fa';
import { BsTelegram, BsTwitter, BsFacebook, BsYoutube, BsMedium, BsReddit } from 'react-icons/bs';
import { SiGmail } from 'react-icons/si';
import { BiUserVoice } from 'react-icons/bi';
import { FaDiscord, FaTimes } from 'react-icons/fa';
import Modal from "./Modal";
import validator from 'validator'
import { NavLink } from 'react-router-dom';
import Footer from './../users/Footer'

const Lihat = () => {

  const [error, setError] = useState('');
  const [loading, setLoading] = useState();
  const [showNotification, setShowNotification] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    return () => {
      clearTimeout(timeoutId);
    };
  }, [timeoutId]);

  const { user, lihatPasukan, detailPasukan, deletePasukan, updatePasukan } = UserAuth();

  const uname = user.displayName;

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(7);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await lihatPasukan(uname);
        setData(result);
      } catch (error) {
        setShowNotification(true);
        setError(error);
      }
      setLoading(false);
    };

    fetchData();
    setTimeoutId(setTimeout(() => setShowNotification(false), 7000));
  }, [lihatPasukan, uname]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const filteredData = useMemo(() => {
    return data.filter((item) => {
      return (
        item.telegram.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.twitter.toLowerCase().includes(searchQuery.toLowerCase())
      );
    });
  }, [data, searchQuery]);

  const startIndex = filteredData.length > 0 ? currentPage * itemsPerPage + 1 : 0;
  const endIndex = Math.min(startIndex + itemsPerPage - 1, filteredData.length);
  const itemsToShow = filteredData.slice(startIndex - 1, endIndex);


  const [nohpTelegram, setNohpTelegram] = useState('');
  const [usernameTelegram, setUsernameTelegram] = useState('');
  const [twitter, setTwitter] = useState('');
  const [email, setEmail] = useState('');
  const [facebook, setFacebook] = useState('');
  const [youtube, setYoutube] = useState('');
  const [medium, setMedium] = useState('');
  const [reddit, setReddit] = useState('');
  const [discord, setDiscordd] = useState('');

  /* Handle Form Input */
  const setHandleInput = (id, e) => {
    if (id === 'nohpTelegram') {
      setNohpTelegram(e.target.value);
    } else if (id === 'usernameTelegram') {
      setUsernameTelegram(e.target.value);
    } else if (id === 'twitter') {
      setTwitter(e.target.value);
    } else if (id === 'email') {
      setEmail(e.target.value);
    } else if (id === 'facebook') {
      setFacebook(e.target.value);
    } else if (id === 'youtube') {
      setYoutube(e.target.value);
    } else if (id === 'medium') {
      setMedium(e.target.value);
    } else if (id === 'reddit') {
      setReddit(e.target.value);
    } else if (id === 'discord') {
      setDiscordd(e.target.value);
    }
  };

  /* Form Data */
  const formData = [
    { id: 'nohpTelegram', title: 'Telegram', color: 'text-telegram', icon: <BsTelegram />, desc: 'Masukkan No. Hp Telegram' },
    { id: 'usernameTelegram', title: '*Username Telegram (Harus diisi)', color: 'text-telegram', icon: <BsTelegram />, desc: 'Masukkan Username Telegram' },
    { id: 'twitter', title: '*Twitter (Harus diisi)', color: 'text-twitter', icon: <BsTwitter />, desc: 'Masukkan Link/Username Twitter' },
    { id: 'email', title: 'Email / Gmail', color: 'text-gmail', icon: <SiGmail />, desc: 'Masukkan Alamat Email' },
    { id: 'discord', title: 'Discord', color: 'text-discord', icon: <FaDiscord />, desc: 'Masukkan Username Discord' },
    { id: 'facebook', title: 'Facebook', color: 'text-facebook', icon: <BsFacebook />, desc: 'Masukkan Link Facebook' },
    { id: 'youtube', title: 'Youtube', color: 'text-youtube', icon: <BsYoutube />, desc: 'Masukkan Link Channel Youtube' },
    { id: 'medium', title: 'Medium', color: 'text-black', icon: <BsMedium />, desc: 'Masukkan Link Medium' },
    { id: 'reddit', title: 'Reddit', color: 'text-reddit', icon: <BsReddit />, desc: 'Masukkan Link Reddit' }
  ]

  // Render the form with the updated values
  const formElement = formData.map((hasil, i) =>
    <label className="block py-1" key={i}>
      <div className="relative">
        <span className="absolute inset-y-0 left-0 pl-0 flex items-center text-zinc-500 icon">
          {hasil.icon}
        </span>
        <input onChange={(e) => {
          setHandleInput(hasil.id, e)
          const icon = e.target.parentNode.querySelector(".icon");
          if (hasil.color !== undefined) {
            if (e.target.value) {
              icon.classList.remove('text-zinc-500');
              icon.classList.add(hasil.color);
            } else {
              icon.classList.add('text-zinc-500');
              icon.classList.remove(hasil.color);
            }
          }
        }}
          type="text"
          placeholder={hasil.desc}
          className="mt-0 block w-full font-normal text-zinc-900 text-sm pl-8 pr-1 px-1 border-0 border-b border-gray-300 focus:ring-0 focus:border-zinc-600"
          autoComplete="off"
          value={
            hasil.id === 'nohpTelegram' ? nohpTelegram :
              hasil.id === 'usernameTelegram' ? usernameTelegram :
                hasil.id === 'twitter' ? twitter :
                  hasil.id === 'email' ? email :
                    hasil.id === 'facebook' ? facebook :
                      hasil.id === 'youtube' ? youtube :
                        hasil.id === 'medium' ? medium :
                          hasil.id === 'reddit' ? reddit :
                            hasil.id === 'discord' ? discord : ''
          }
        />
      </div>
    </label>
  );

  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
  };

  const [selectedTelegram, setSelectedTelegram] = useState(null);

  useEffect(() => {
    if (selectedTelegram) {
      const fetchData = async () => {
        try {
          const result = await detailPasukan(uname, selectedTelegram);
          setNohpTelegram(result[0].nohpTelegram);
          setUsernameTelegram(result[0].usernameTelegram);
          setTwitter(result[0].twitter);
          setEmail(result[0].email);
          setFacebook(result[0].facebook);
          setYoutube(result[0].youtube);
          setMedium(result[0].medium);
          setReddit(result[0].reddit);
          setDiscordd(result[0].discord);
        } catch (error) {
          setShowNotification(true);
          setError(error);
        }
      };

      fetchData();
    }
  }, [selectedTelegram, uname, detailPasukan]);

  const hapusPasukan = async (deleteTarget) => {
    setLoading(true);
    try {
      const result = await deletePasukan(uname, deleteTarget);
      if (result === true) {
        setData(data.filter(item => item.telegram !== deleteTarget));
        setShowNotification(true);
        setError(`Pasukan ${deleteTarget} dihapus`);
      } else {
        throw new Error(result);
      }
    } catch (e) {
      setShowNotification(true);
      setError(`Gagal: ${e}`);
    }
    setLoading(false);
  };



  const [limit, setLimit] = useState(50);

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth < 768) {
        setLimit(11);
      } else {
        setLimit(25);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowNotification(false);
    setLoading(true);
    try {
      const maxLength = 96;
      if (nohpTelegram !== "" && !validator.isMobilePhone(nohpTelegram)) {
        throw new Error('No. Hp. Telegram tidak valid');
      }
      if (!usernameTelegram) {
        throw new Error('Username Telegram harus diisi');
      }
      if (!twitter) {
        throw new Error('Link/Username Twitter harus diisi ')
      }
      if (
        nohpTelegram?.length >= maxLength && usernameTelegram?.length >= maxLength &&
        twitter?.length >= maxLength && email?.length >= maxLength &&
        facebook?.length >= maxLength && youtube?.length >= maxLength &&
        medium?.length >= maxLength && reddit?.length >= maxLength && discord?.length >= maxLength
      ) {
        throw new Error('Input value tidak boleh lebih dari 96 karakter')
      }
      if (twitter.length < 4) {
        throw new Error('Username Twitter harus lebih dari 4 karakter')
      }
      if (usernameTelegram.length < 5) {
        throw new Error('Username Telegram harus lebih dari 5 karakter')
      }
      await updatePasukan(
        selectedTelegram,
        uname,
        nohpTelegram, usernameTelegram, twitter,
        email, facebook, youtube,
        medium, reddit, discord
      );
      // Fetch the latest data and update the state
      const result = await lihatPasukan(uname);
      setData(result);
      setShowNotification(true);
      setError('Pasukan ' + selectedTelegram + ' berhasil diperbarui');
      handleModalClose(); // Close the modal after successful update
    } catch (e) {
      setShowNotification(true);
      switch (e.code) {
        default:
          setError(e.message);
          break;
      }
    } finally {
      setLoading(false);
      setTimeoutId(setTimeout(() => setShowNotification(false), 7000));
    }
  }
  return (
    <div className="antialiased bg-primary md:block md:bg-indigo-50" style={{ backgroundImage: `url('/images/bg-body.png')` }} relative>
      <NavHeader />
      <div className="max-w-[600px] mx-auto min-h-screen bg-slate-100 shadow-2xl relative">
        <Header />
        {loading && (
          <div className="absolute top-0 left-0 right-0 bottom-0 bg-black opacity-60 flex items-center justify-center z-50">
            <img src='/logo192.png' alt="Loading..." className="w-10 h-10" />
          </div>
        )}
        {showNotification && (
          <div className="px-4 fixed bottom-0 w-full max-w-[600px] transform mb-8 animate-fade-in animate-slide-up z-50">
            <div className="bg-stone-900 text-white w-full rounded p-4 text-sm font-semibold flex justify-between">
              {error}
              <span className="text-primary cursor-pointer" onClick={() => setShowNotification(false)}>Ok</span>
            </div>
          </div>
        )}
        <div className='pt-3 pb-[96px]'>
          <div className='bg-white'>
            <div className='px-4 pt-4 pb-2 md:p-4 flex justify-between items-center border-b-4 border-slate-100'>
              <div className='flex items-center'>
                <span className="mr-2">
                  <FaUserAstronaut className='h-[14px] w-[14px] md:h-[16px] md:w-[16px]' />
                </span>
                <h1 className='font-semibold text-base md:text-lg'>Lihat Pasukan</h1>
              </div>
              <div className='text-primary md:font-semibold font-bold text-sm md:text-base'>
                Pelajari
              </div>
            </div>
            <div className='p-4'>
              <div className='flex justify-between pb-4 items-center'>
                <div className='md:block hidden'>
                  <NavLink to='/pasukan/add'>
                    <button className='text-white flex items-center px-4 py-2 bg-sky-600 rounded-md border border-sky-500 text-sm font-medium'>
                      <span className='mr-2'>
                        <BiUserVoice size='20' />
                      </span>
                      <span>Tambah Pasukan</span>
                    </button>
                  </NavLink>
                </div>
                <div className='ml-auto'>
                  <SearchField
                    placeholder="Search..."
                    onChange={(value) => {
                      setSearchQuery(value);
                      setCurrentPage(0);
                    }}
                  />
                </div>
              </div>
              <div className="overflow-x-auto">
                <table className='w-full items-center text-left table-auto'>
                  <thead className='font-medium text-sm text-zinc-600 border-b border-t'>
                    <tr>
                      <th className='py-2 px-3  w-1/12'>No.</th>
                      <th className='py-2 px-3'>Telegram</th>
                      <th className='py-2 px-3'>Twitter</th>
                      <th className='py-2 px-3  w-1/12'>Action</th>
                    </tr>
                  </thead>
                  <tbody className='font-normal text-sm text-zinc-600 border-b'>
                    {itemsToShow.map((item, index) => (
                      <tr key={item.id} className='hover:bg-gray-200'>
                        <td className='py-2 px-3  w-1/12'>{startIndex + index + 1}</td>
                        <td className='py-2 px-3'>
                          {item.telegram.length > limit ? (
                            <span title={item.telegram}>{item.telegram.slice(0, limit)}...</span>
                          ) : (
                            <span>{item.telegram}</span>
                          )}
                        </td>
                        <td className='py-2 px-3'>
                          {item.twitter.length > limit ? (
                            <span title={item.twitter}>{item.twitter.slice(0, limit)}...</span>
                          ) : (
                            <span>{item.twitter}</span>
                          )}
                        </td>
                        <td className='py-2 px-3  w-1/12'>
                          <div className='flex justify-start'>
                            <button onClick={() => {
                              setShowModal(true);
                              setSelectedTelegram(item.telegram);
                            }} className='mr-1'>
                              <FaEdit size='16px' className='text-green-500' />
                            </button>
                            <button onClick={() => hapusPasukan(item.telegram)}
                             className='ml-1'>
                              <FaTrash size='16px' className='text-red-600' />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className='text-sm text-zinc-600 mt-4'>
  Showing {startIndex > 0 ? startIndex : 0} to {endIndex} of {filteredData.length} entries
</div>
              <ReactPaginate
                previousLabel={
                  <span className="px-4 py-2">
                    &lt;
                  </span>
                }
                nextLabel={
                  <span className="px-4 py-2">
                    &gt;
                  </span>
                }
                breakLabel='...'
                pageCount={Math.ceil(filteredData.length / itemsPerPage)}
                marginPagesDisplayed={1}
                pageRangeDisplayed={2}
                onPageChange={handlePageChange}
                containerClassName={'flex justify-center mt-4 text-sm'}
                activeClassName={'bg-primary text-white px-4 py-2 !important'}
                pageClassName={'border border-gray-100 px-4 py-2'}
                breakClassName={'border border-gray-100 px-4 py-2'}
                previousClassName={'border border-gray-100 px-4 py-2'}
                nextClassName={'border border-gray-100 px-4 py-2'}
              />

            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onClose={handleModalClose}>
        <div className="flex justify-end">
          <button onClick={handleModalClose}>
            <FaTimes className="text-gray-400 hover:text-gray-500" />
          </button>
        </div>
        <h2 className="text-lg font-bold mb-4">Edit Data Pasukan - <span className='box-decoration-slice bg-gradient-to-r from-cyan-500 to-primary text-white px-2'>{selectedTelegram}</span></h2>
        <form onSubmit={handleSubmit}>
          <div className=''>
            {formElement}
          </div>
          <div className='mx-auto pt-6'>
            <button className="py-1 px-2 rounded-md font-semibold text-white bg-primary flex flex-row justify-center items-center hover:bg-secondary focus:outline-none focus:bg-secondary" type="submit">Edit Pasukan</button>
          </div>
        </form>
      </Modal>
      <Footer />
    </div>
  )
}

export default Lihat
